(function () {
  if (typeof window === 'undefined' || typeof window.routes === 'undefined' || !window.routes.free_product_1_id) {
    return;
  }

  function toNumber(value) {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }

  function getVariantId(item) {
    return item.variant_id || item.id;
  }

  function calculateGiftUpdates(cart) {
    const items = cart && cart.items ? cart.items : [];

    const freeProduct1Id = parseInt(window.routes.free_product_1_id, 10);
    const hasSecondGift = !!window.routes.free_product_2_id;
    const freeProduct2Id = hasSecondGift ? parseInt(window.routes.free_product_2_id, 10) : NaN;
    const excludeProductId = window.routes.exclude_product_id
      ? parseInt(window.routes.exclude_product_id, 10)
      : null;

    if (Number.isNaN(freeProduct1Id)) {
      return null;
    }

    const freeIds = [freeProduct1Id];
    if (hasSecondGift && !Number.isNaN(freeProduct2Id)) {
      freeIds.push(freeProduct2Id);
    }

    let subtotalCents = 0;
    let hasExcludeProduct = false;
    let currentFree1Qty = 0;
    let currentFree2Qty = 0;

    items.forEach((item) => {
      const variantId = getVariantId(item);
      const quantity = item.quantity || 0;

      if (!variantId) return;

      if (variantId === freeProduct1Id) {
        currentFree1Qty += quantity;
      } else if (hasSecondGift && variantId === freeProduct2Id) {
        currentFree2Qty += quantity;
      }

      if (excludeProductId && variantId === excludeProductId) {
        hasExcludeProduct = true;
      }

      if (!freeIds.includes(variantId) && !(excludeProductId && variantId === excludeProductId)) {
        const linePrice =
          typeof item.final_line_price === 'number'
            ? item.final_line_price
            : typeof item.line_price === 'number'
            ? item.line_price
            : (item.price || 0) * quantity;
        subtotalCents += linePrice;
      }
    });

    const threshold1 = toNumber(window.routes.free_product_1_threshold);
    const threshold2 = hasSecondGift ? toNumber(window.routes.free_product_2_threshold) : Infinity;
    const subtotal = subtotalCents / 100;

    let desiredFree1Qty = 0;
    let desiredFree2Qty = 0;

    if (subtotal >= threshold1) {
      if (hasSecondGift && subtotal >= threshold2) {
        desiredFree1Qty = 1;
        desiredFree2Qty = 1;
      } else {
        desiredFree1Qty = 1;
        desiredFree2Qty = 0;
      }
    } else {
      desiredFree1Qty = 0;
      desiredFree2Qty = 0;
    }

    const updates = {};

    if (!Number.isNaN(freeProduct1Id) && currentFree1Qty !== desiredFree1Qty) {
      updates[freeProduct1Id] = desiredFree1Qty;
    }

    if (hasSecondGift && !Number.isNaN(freeProduct2Id) && currentFree2Qty !== desiredFree2Qty) {
      updates[freeProduct2Id] = desiredFree2Qty;
    }

    return Object.keys(updates).length ? updates : null;
  }

  let isProcessing = false;

  function applyGiftUpdates(cart) {
    const updates = calculateGiftUpdates(cart);
    if (!updates || isProcessing) return Promise.resolve(null);

    isProcessing = true;

    const body = JSON.stringify({ updates });

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig('json'), ...{ body } })
      .then((response) => response.json())
      .then((updatedCart) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-products', cartData: updatedCart });
        return updatedCart;
      })
      .catch((error) => {
        console.error('Error updating free products', error);
        return null;
      })
      .finally(() => {
        isProcessing = false;
      });
  }

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => applyGiftUpdates(cart))
    .catch((error) => {
      console.error('Error fetching cart on initial load for free products', error);
    });

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || !event.cartData) return;
    applyGiftUpdates(event.cartData);
  });
})();